import { Button, CircularProgress, FormControl, FormControlLabel, FormGroup, Paper, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { getApiUrl } from '../../env'
import {Helmet} from "react-helmet";

const Contribute = () => {
    const [currentNews, setCurrentNews] = useState({})
    const [selectedBias, setSelectedBias] = useState(1);
    const [additionalComment, setAdditionalComment] = useState("");

    const handleClose = ev => {
        console.log(selectedBias, additionalComment);
        setCurrentNews({});
        axios.post(getApiUrl() + "feedback/bias", { "comment": additionalComment, "suggestedBias": selectedBias, "newsItemId": currentNews.id })
            .then(res => {
                getNews()
            })
            .catch(er => {
            })
    }
    const getNews = () => {
        axios.get(getApiUrl() + "feedback/bias").then(res => {
            setCurrentNews(res.data)
            setSelectedBias(1)
            setAdditionalComment("")
        })
    }

    useEffect(() => {
        getNews()
    }, [])
    return (
        <div>
            <Helmet>
                <title>Придонеси | Читај!</title>
            </Helmet>
            {Object.keys(currentNews).length == 0 ?
                <Paper elevation={1} style={{ textAlign: 'center', padding: '30px' }}>
                    <CircularProgress size={100} thickness={5} style={{ marginBottom: '20px' }} />
                    <br />
                    <Typography variant={'p'} color={'white'}>Ве молиме почекајте</Typography>
                </Paper> :
                <div style={{ textAlign: 'start' }}>
                    <Typography style={{margin:'10px'}} variant={'p'} color={'white'}><b>Прочитајте го текстот и одберете пристрасност</b></Typography>
                    <br/>
                    <Paper elevation={1} style={{ textAlign: 'start', padding: '30px', margin: '10px' }}>
                        <Typography variant={'h5'} color={'white'}>{currentNews.title}</Typography>
                        <br />
                        <Typography variant={'p'} fontSize={14} color={'text.secondary'}>{currentNews.text}</Typography>
                    </Paper>
                    <Paper elevation={1} style={{ textAlign: 'start', padding: '30px', margin: '10px' }}>
                        <FormControl style={{ width: '100%' }}>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue={1}
                                name="radio-buttons-group"
                                value={selectedBias}
                                onChange={(ev) => setSelectedBias(ev.target.value)}
                            >
                                <FormControlLabel value={1} control={<Radio />} label="Неутрално" />
                                <FormControlLabel value={0} control={<Radio />} label="Пристрасно кон СДСМ" />
                                <FormControlLabel value={2} control={<Radio />} label="Пристрасно кон ВМРО-ДПМНЕ" />
                            </RadioGroup>
                            <TextField
                                value={additionalComment}
                                onChange={(ev) => setAdditionalComment(ev.target.value)}
                                label="Дополнителен коментар (незадолжително)"
                                variant="standard"
                            />
                        </FormControl>
                        <div style={{ height: '30px', marginTop: '10px' }}>
                            <Button onClick={handleClose} variant="contained" style={{ float: 'right', marginLeft: '10px' }}>Прати</Button>
                            <Button onClick={getNews} variant="contained" style={{ float: 'right' }} color={'secondary'}>Прескокни</Button>
                        </div>
                    </Paper>
                </div>
            }

        </div>
    )
}
export default Contribute;